import React, { useState } from "react";
import styled from "styled-components";
import { Flex, Image, P, ResponsiveSVG } from "ui/acro";
import { Text } from "ui/bend";
import { AlomovesIconSVG } from "images/latest";
import PlayListClassAction from "./PlayListClassAction";

const Title = styled("a")`
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 18px;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.396px;
  width: 80%;
  cursor: pointer;
  &:hover,
  :visited,
  :active {
    color: ${(props) => props.theme.colors.black};
  }
`;
const AuthorName = styled(Text)`
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.308px;
  text-transform: capitalize;
  color: ${(props) => props.theme.colors.black};
`;
const CompletedText = styled(Text)`
  color: ${(props) => props.theme.colors.success.medium};
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.308px;
`;
const Duration = styled(Text)`
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 16.1px */
  color: ${(props) => props.theme.colors.black};
`;

const PlaylistClass = ({
  classObject,
  author,
  userIsAuthor,
  uuid,
  setUpdateClassList,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { videoThumbnail, title, humanDuration, completedAt, planEntryUrl } =
    classObject;

  const getLocalDate = (d) => {
    let date = new Date(d);
    if (moment(date).isValid()) {
      return moment(date).local().format("MM/DD/YYYY");
    }

    date = String(d).replace(/-/g, "/");
    if (moment(date).isValid()) {
      return moment(date).local().format("MM/DD/YYYY");
    }

    return String(d);
  };

  return (
    <Flex gap="8px">
      <Flex width={["30%", "30%", "20%", "20%"]} as="a" href={planEntryUrl}>
        {videoThumbnail ? (
          <Image
            src={videoThumbnail}
            objectFit="cover"
            position="absolute"
            top="0"
            left="0"
            style={{ aspectRatio: "16/9" }}
          />
        ) : (
          <ResponsiveSVG
            SVG={AlomovesIconSVG}
            className="no-thumbnail"
            style={{ aspectRatio: "16/9" }}
          />
        )}
      </Flex>
      <Flex flex="1" flexDirection="column">
        <Flex justifyContent="space-between" alignItems="center">
          {title && <Title href={planEntryUrl}>{title}</Title>}
          <P
            style={{ color: "#000", cursor: "pointer", margin: "0" }}
            onClick={() => setIsOpen(true)}
          >
            • • •
          </P>
          <PlayListClassAction
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            dataObj={classObject}
            author={author}
            userIsAuthor={userIsAuthor}
            uuid={uuid}
            setUpdateClassList={setUpdateClassList}
          />
        </Flex>
        {author.firstName && (
          <AuthorName>{`${author.firstName} ${author.lastName}`}</AuthorName>
        )}
        <Duration>{humanDuration}</Duration> 
        <Flex alignItems="flex-end" flexGrow="1" gap="32px">
          {completedAt ? (
            <CompletedText>
              Completed: {getLocalDate(completedAt)}
            </CompletedText>
          ) : null}
          
        </Flex>
      </Flex>
    </Flex>
  );
};
PlaylistClass.propTypes = {};

export default PlaylistClass;
